<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">
        {{(!canEdit ? 'courseEqualization_viewCourseTitle' : model.Id ? 'courseEqualization_editCourseTitle' : 'courseEqualization_addCourseTitle') | translate}}
    </h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <ng-container *ngIf="step == 0">
            <div class="form-field">
                <label class="form-label">
                    {{'courseEqualization_lblInnerCourse' | translate}}
                    <span class="required-mark"></span>
                    <span [ngbTooltip]="'courseEqualization_hintInnerCourse' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>
                <app-select [(ngModel)]="innerCourse"
                            [options]="innerCourseOptions"
                            [displayFn]="courseDisplayFn"
                            [required]="true"
                            [disabled]="!canEdit"
                            name="innerCourse"
                            [filter]="courseFilterFn">
                </app-select>
            </div>

            <div class="form-field">
                <label class="form-label">
                    {{'courseEqualization_lblCourseType' | translate}}
                    <span class="required-mark"></span>
                    <span [ngbTooltip]="'courseEqualization_hintCourseType' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>
                <app-select [(ngModel)]="type"
                            [options]="typeOptions"
                            [displayProperty]="'Value'"
                            [required]="true"
                            [disabled]="!canEdit"
                            (selectionChange)="onTypeChange($event)"
                            name="type">
                </app-select>
            </div>

            <div class="form-field required" *ngIf="universityVisible">
                <label class="form-label">{{'courseEqualization_lblUniversity' | translate}}</label>
                <input class="form-control" required [(ngModel)]="model.University" name="university" [disabled]="!canEdit" />
            </div>

            <div class="form-field required" *ngIf="programmeVisible">
                <label class="form-label">{{'courseEqualization_lblProgrammeName' | translate}}</label>
                <input class="form-control" required [(ngModel)]="model.Programme" name="programme" [disabled]="!canEdit" />
            </div>

            <div class="form-field">
                <label class="form-label">
                    {{'courseEqualization_lblCourseName' | translate}}
                    <span class="required-mark"></span>
                    <span [ngbTooltip]="'courseEqualization_hintCourseName' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>
                <input class="form-control" required [(ngModel)]="model.Name" name="name" [disabled]="!canEdit" />
            </div>

            <div class="form-field" *ngIf="notesVisible">
                <label class="form-label">{{'courseEqualization_lblNotes' | translate}}</label>
                <textarea class="form-control" [(ngModel)]="model.Notes" rows="5" name="notes" [disabled]="!canEdit"></textarea>
            </div>
        </ng-container>

        <ng-container *ngIf="step == 1">
            <div class="col-sm form-field">
                <label class="form-label">
                    {{'courseEqualization_lblWeeks' | translate}}
                    <span [ngbTooltip]="'courseEqualization_hintWeeks' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>
                <input class="form-control" [(ngModel)]="model.Weeks" name="weeks" pattern="^[1-9][0-9]{0,2}$" [disabled]="!canEdit" />
            </div>

            <div class="row">
                <div class="col-sm form-field">
                    <label class="form-label">{{'courseEqualization_lblDateFrom' | translate}}</label>
                    <app-date [(ngModel)]="model.DateFrom" name="dateFrom" [max]="model.DateTo" [disabled]="!canEdit"></app-date>
                </div>

                <div class="col-sm form-field">
                    <label class="form-label">{{'courseEqualization_lblDateTo' | translate}}</label>
                    <app-date [(ngModel)]="model.DateTo" name="dateTo" [min]="model.DateFrom" [disabled]="!canEdit"></app-date>
                </div>
            </div>

            <app-alert level="warning" *ngIf="dateRangeInvalid">
                {{'courseEqualization_dateRangeInvalid' | translate}}
            </app-alert>

            <div class="row">
                <div class="col-sm form-field">
                    <label class="form-label">
                        {{'courseEqualization_lblEcts' | translate}}
                        <span class="required-mark"></span>
                        <span [ngbTooltip]="'courseEqualization_hintEcts' | translate" class="fi fi-rs-interrogation ms-1"></span>
                    </label>
                    <input class="form-control" [(ngModel)]="model.Ects" name="ects" required [pattern]="pointValidationPattern" [disabled]="!canEdit" />
                </div>

                <div class="col-sm form-field">
                    <label class="form-label">{{'courseEqualization_lblFurtherEducationPoints' | translate}}</label>
                    <input class="form-control" [(ngModel)]="model.FurtherEducationPoints" name="furtherEducationPoints" [pattern]="pointValidationPattern" [disabled]="!canEdit" />
                </div>
            </div>

            <div class="row">
                <div class="col-sm form-field">
                    <label class="form-label">
                        {{'courseEqualization_lblTheory' | translate}}
                        <span [ngbTooltip]="'courseEqualization_hintTheory' | translate" class="fi fi-rs-interrogation ms-1"></span>
                    </label>
                    <app-select [(ngModel)]="model.TheoryGradeId"
                                [options]="gradeOptions"
                                [valueProperty]="'Id'"
                                [displayProperty]="'Value'"
                                [disabled]="!canEdit"
                                name="theory">
                    </app-select>
                </div>

                <div class="col-sm form-field">
                    <label class="form-label">
                        {{'courseEqualization_lblPractice' | translate}}
                        <span class="required-mark"></span>
                        <span [ngbTooltip]="'courseEqualization_hintPractice' | translate" class="fi fi-rs-interrogation ms-1"></span>
                    </label>
                    <app-select [(ngModel)]="model.PracticeGradeId"
                                [options]="gradeOptions"
                                [valueProperty]="'Id'"
                                [displayProperty]="'Value'"
                                [required]="true"
                                [disabled]="!canEdit"
                                name="practice">
                    </app-select>
                </div>
            </div>

            <div class="form-field">
                <label class="form-label">
                    {{'courseEqualization_lblSupportingDocuments' | translate}}
                    <span class="required-mark"></span>
                    <span [ngbTooltip]="'courseEqualization_hintAttachments' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>

                <div *ngFor="let a of model.Attachments; let i = index" class="d-flex mb-2">
                    <div class="flex-grow-1">
                        <app-file [(ngModel)]="a.File"
                                  [accept]="attachmentExtensions"
                                  [maxSize]="attachmentMaxSize"
                                  name="attachment{{i}}"
                                  [immediate]="!a.Id && !a.File && !a.FileName"
                                  [disabled]="!canEdit && a.Id"
                                  (fileChange)="onFileChange($event, a)"
                                  #attachmentInput="ngModel"></app-file>
                        <div class="invalid-feedback" *ngIf="!a.FileName">{{'courseEqualization_emptyAttachment' | translate}}</div>
                        <div class="invalid-feedback" *ngIf="checkDuplicateFileName(a)">{{'courseEqualization_duplicateFileName' | translate}}</div>
                    </div>

                    <button class="btn btn-outline btn-icon align-self-end ms-3" *ngIf="a.Id"
                            (click)="downloadAttachment(a)" [ngbTooltip]="'download' | translate">
                        <i class="fi fi-rs-download"></i>
                    </button>
                </div>

                <div *ngIf="canEdit || canOnlyAppendFiles">
                    <button class="btn btn-tertiary" type="button" (click)="addAttachment()">
                        <i class="fi fi-rs-plus"></i>
                        {{'courseEqualization_btnAddSupportingDocument' | translate}}
                    </button>
                </div>

                <div class="invalid-feedback" *ngIf="model.Attachments.length < 1">{{'courseEqualization_supportingDocumentRequired' | translate}}</div>
            </div>
        </ng-container>
    </form>

    <div class="steps">
        <span class="step" [class.active]="step == 0" (click)="step = 0"></span>
        <span class="step" [class.active]="step == 1" (click)="step = 1"></span>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">
        {{(!canEdit ? 'dialog_close' : 'dialog_cancel') | translate}}
    </button>

    <button class="btn btn-primary" type="button" (click)="step = 1" [disabled]="!isValid" *ngIf="step == 0">
        {{'courseEqualization_btnNext' | translate}}
    </button>

    <button class="btn btn-primary" type="button" (click)="ok()" [disabled]="!isValid" *ngIf="step == 1 && (canEdit || canOnlyAppendFiles)">
        {{'dialog_ok' | translate}}
    </button>
</div>
